import { FieldConfig } from '../../common/field-types';
import { renderRateScheduleField } from '../_shared';
import {
  GENDER_OPTIONS,
  LifeMaxFormValues,
  RATE_MODE_OPTIONS,
  RECOMMENDED_RATE_FROM_2028,
  RECOMMENDED_RATE_UNTIL_2027,
  isFixedRate,
  isSteppedRate,
} from './schema';

const CLIENTE = 'Datos del cliente';
const CAPITALES = 'Capitales';
const MODO = 'Modo y campos específicos';
const APORTES = 'Aportes y primas';

export const LIFE_MAX_FIELDS: readonly FieldConfig<LifeMaxFormValues>[] = [
  {
    key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date', section: CLIENTE,
  },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS, section: CLIENTE,
  },
  {
    key: 'death_insured_capital',
    label: 'Capital asegurado de fallecimiento',
    kind: 'number',
    hint: 'UF (mínimo: max(150, 1,5% de la prima única). Máximo 20.000 (<66 años) o 2.500 (≥66)).',
    section: CAPITALES,
  },
  {
    key: 'rate_mode', label: 'Modo de tasa', kind: 'select', options: RATE_MODE_OPTIONS, section: MODO,
  },
  {
    key: 'projection_rate',
    label: 'Tasa de proyección',
    kind: 'number',
    hint: `Anual real. Preset tasa fija: ${RECOMMENDED_RATE_UNTIL_2027 * 100}% hasta dic-2027, ${RECOMMENDED_RATE_FROM_2028 * 100}% desde ene-2028. Máximo 5%.`,
    step: 0.001,
    visibleWhen: isFixedRate,
    section: MODO,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    hint: 'Cada tramo aplica hasta el mes "Hasta" inclusive. El último puede dejarse "para siempre".',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
    section: MODO,
  },
  {
    key: 'initial_contribution',
    label: 'Aporte inicial',
    kind: 'number',
    hint: 'UF — mínimo 3.000 UF (prima única de entrada).',
    section: APORTES,
  },
  {
    key: 'unscheduled_annual_contribution',
    label: 'Aporte anual',
    kind: 'number',
    hint: 'UF (depósito anual no pactado en cada aniversario).',
    section: APORTES,
  },
  {
    key: 'direct_contribution_amount',
    label: 'Aporte único',
    kind: 'number',
    hint: 'UF — aporte único adicional que aterriza en el mes elegido.',
    colClassName: 'col-md-6',
    section: APORTES,
  },
  {
    key: 'direct_contribution_month',
    label: 'Mes del aporte único',
    kind: 'number',
    hint: '1 = inicio. Base 1. Se ignora si el aporte es 0.',
    colClassName: 'col-md-6',
    section: APORTES,
  },
];
